import { generateHTML } from '@tiptap/html';

import { getExtensions } from '../hooks/use-article-tiptap-editor/extensions';

export const generateHTMLArticleContent = (articleContent: string): string => {
  try {
    const parsedArticleContent = JSON.parse(articleContent);

    return generateHTML(parsedArticleContent, getExtensions());
  } catch {
    return '';
  }
};
